import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';

import { formatDate } from 'apps/shared/scripts/utils';

import SignatureItemTag from './SignatureItemTag';
import { signatureItemFooterClassName } from './styles';

interface Props {
  signedAt: string;
}

const SignatureItemFooter = ({ signedAt }: Props) => {
  return (
    <div className={signatureItemFooterClassName}>
      <SignatureItemTag faIcon={faPenToSquare} label={formatDate(signedAt)} />
    </div>
  );
};

SignatureItemFooter.displayName = 'SignatureItemFooter';

export default SignatureItemFooter;
